import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new-page",
  "use": "icon-new-page-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-new-page\">\n    \n   \n        <path d=\"M0.8,12 L23.2,12 M12,0 L12,24\" id=\"icon-new-page_Combined-Shape\" stroke-width=\"2\" />\n  \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol